import { QueryClient } from "@tanstack/react-query";
import { ApiRequestError } from "./api-client";

/** Retries only failures that can pass on retry (network, 5xx), never 4xx. */
export function createQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 15_000,
        retry: (failures, error) =>
          failures < 2 &&
          (!(error instanceof ApiRequestError) || error.status === 0 || error.status >= 500),
        refetchOnWindowFocus: true,
      },
    },
  });
}
